import { ScoopTextField } from '../../../../../ui'
import { ScoopSpinner } from '../../../../../ui'
import styles from './ModifyInput.module.scss'

/**
 * Modification input step - shown when user wants to change the configuration
 * @param {Object} props
 * @param {string} props.value - Current modification text
 * @param {Function} props.onChange - Called when text changes
 * @param {boolean} props.loading - Loading state
 */
export const ModifyInput = ({ value, onChange, loading }) => {
    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <ScoopSpinner size={40} />
                <span className={styles.loadingText}>Updating configuration...</span>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>What would you like to change?</h3>
            <p className={styles.subtitle}>
                Describe the changes you'd like to make to the configuration.
            </p>

            <ScoopTextField
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="e.g., Add the pipeline field and remove the record ID..."
                multiline
                rows={3}
                autoFocus
            />
        </div>
    )
}
